import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { FusePageSimple, DemoContent } from '@fuse';

// import {  FormControlLabel, MenuItem, Radio, Typography, Icon, IconButton } from 'material-ui';
import { Button, Select, Input, MenuItem, TextField, InputLabel } from 'material-ui';
import { TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import Formsy from 'formsy-react';
import $ from 'jquery';
import ReactTable from "react-table";
import axios from 'axios/index';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from 'material-ui/Dialog';
import Loader from "other-components/loader/loader";
import { withAlert } from 'react-alert';
import Icon from 'material-ui/Icon';
import IconButton from 'material-ui/IconButton';
import moment from 'moment';


const styles = theme => ({
    layoutRoot: {}
});
var reference_no = null;
var id = null;
var customer_code = null;
var customer_name = null;
var grows_amount = null;
var discount = null;
var out_standing = null;
var net_amount = null;
var status = null;
var invoice_date = null;


class InvoiceView extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            loading: true,
            value: '',
            selectValue: 0,
            search_type: 'invoice'

        };

        this.populateFileds();

    }

    populateFileds() {
        this.loadData(this.state.search_type);
        // this.setState({ loading: false });

    }

    handleSearchAny = (e) => {

        this.setState({
            value: e.target.value
        });
        // this.loadSearchData(e.target.value)
    }

    convertToInvoice(id, reference_no) {
        const invoiceObj = {
            id: id
        }
        // axios.post('http://localhost:5006/invoice/updateProformaInvoice ', invoiceObj)
        axios.post(window.salesServer + '/invoice/updateProformaInvoice ', invoiceObj)
            .then(res => {

                if (res.data.success) {
                    // alert(reference_no)
                    var address = null;
                    axios.get(window.reportServer + '/report/get/reportInvoiceDuplicate', {
                        params: {
                            invoiceNo: reference_no
                        }
                    })
                        .then(response => {
                            address = response.data.path;
                            address = window.reportServer + "/" + address;
                            const url = address;
                            window.open(url, '_blank');


                        }
                        );
                    this.loadData(this.state.search_type)
                } else {
                    // alert(res.data.message);
                    this.props.alert.error(res.data.message);
                }
            })
    }

    loadSearchData(searchValue) {
        // this.setState({ loading: true });
        var data = [];
        var discount;
        const searchObj = {
            searchVal: searchValue,
            searchType: this.state.selectValue
        }
        // alert(value)
        // this.setState({ loading: true });
        if (this.state.search_type == 'quatation') {

            // axios.post('http://localhost:5006/quotation/searchQuotationsList', searchObj)
            axios.post(window.salesServer + '/quotation/searchQuotationsList', searchObj)
                .then(response => {

                    if (response.data.success) {
                        var quatationListObj = response.data.quotations;
                        for (var i = 0; i < quatationListObj.length; i++) {
                            if (quatationListObj[i].IS_DISCOUNT_PERCENTAGE) {
                                discount = quatationListObj[i].DISCOUNT + "%"
                            } else {
                                discount = quatationListObj[i].DISCOUNT
                            }
                            data.push({
                                id: quatationListObj[i].REFERENCE_NO,
                                reference_no: quatationListObj[i].REFERENCE_NO,
                                customer_code: quatationListObj[i].CUSTOMER_CODE,
                                customer_name: quatationListObj[i].CUSTOMER_NAME,
                                grows_amount: quatationListObj[i].GROSS_AMOUNT,
                                discount: discount,
                                net_amount: quatationListObj[i].NET_AMOUNT,
                                // out_standing: 'NaN',
                                invoice_date: quatationListObj[i].BILL_DATE,
                                status: quatationListObj[i].STATUS
                            });
                        }
                        this.setState({ data: data });
                        this.setState({ loading: false });
                    } else {
                        // alert("Delete Faild !");
                        this.props.alert.info("No Data Found !");
                        this.setState({ loading: false });
                    }
                }).catch(function (error) {
                    // alert("Error");
                    console.log("No internet connection or Internal error");
                    // this.setState({ loading: false });
                    // alert("No internet connection or Internal error");
                });
        } else if (this.state.search_type == 'proformaInvoice') {
            // axios.post('http://localhost:5006/invoice/searchProfomaInvoicesList', searchObj)
            axios.post(window.salesServer + '/invoice/searchProfomaInvoicesList', searchObj)
                .then(response => {

                    if (response.data.success) {
                        var invoiceListObj = response.data.invoices;

                        for (var i = 0; i < invoiceListObj.length; i++) {
                            if (invoiceListObj[i].IS_DISCOUNT_PERCENTAGE) {
                                discount = invoiceListObj[i].DISCOUNT + "%"
                            } else {
                                discount = invoiceListObj[i].DISCOUNT
                            }
                            data.push({
                                id: invoiceListObj[i].ID_INVOICE_HEADER,
                                reference_no: invoiceListObj[i].REFERENCE_NO,
                                customer_code: invoiceListObj[i].CUSTOMER_CODE,
                                customer_name: invoiceListObj[i].CUSTOMER_NAME,
                                grows_amount: invoiceListObj[i].GROSS_AMOUNT,
                                out_standing: invoiceListObj[i].OUTSTANDING,
                                invoice_date: invoiceListObj[i].BILL_DATE,
                                discount: discount,
                                net_amount: invoiceListObj[i].NET_AMOUNT,
                                status: invoiceListObj[i].STATUS
                            });
                        }
                        this.setState({ data: data },
                            () => {
                                console.log('perfomaInvoiceData', this.state.data);
                            });
                        this.setState({ loading: false });
                    } else {
                        // alert("Delete Faild !");
                        this.props.alert.info("No Data Found !");
                        this.setState({ loading: false });
                    }
                }).catch(function (error) {
                    // alert("Error");
                    console.log("No internet connection or Internal error");
                    // this.setState({ loading: false });
                    // alert("No internet connection or Internal error");
                });
        } else {

            // axios.post('http://localhost:5006/invoice/searchInvoicesList', searchObj)
            axios.post(window.salesServer + '/invoice/searchInvoicesList', searchObj)
                .then(response => {

                    if (response.data.success) {
                        var invoiceListObj = response.data.invoices;

                        for (var i = 0; i < invoiceListObj.length; i++) {
                            if (invoiceListObj[i].IS_DISCOUNT_PERCENTAGE) {
                                discount = invoiceListObj[i].DISCOUNT + "%"
                            } else {
                                discount = invoiceListObj[i].DISCOUNT
                            }
                            data.push({
                                id: invoiceListObj[i].ID_INVOICE_HEADER,
                                reference_no: invoiceListObj[i].REFERENCE_NO,
                                customer_code: invoiceListObj[i].CUSTOMER_CODE,
                                customer_name: invoiceListObj[i].CUSTOMER_NAME,
                                grows_amount: invoiceListObj[i].GROSS_AMOUNT,
                                out_standing: invoiceListObj[i].OUTSTANDING,
                                invoice_date: invoiceListObj[i].BILL_DATE,
                                discount: discount,
                                net_amount: invoiceListObj[i].NET_AMOUNT,
                                status: invoiceListObj[i].STATUS,
                                deleted: invoiceListObj[i].DELETED
                            });
                        }
                        this.setState({ data: data });
                        this.setState({ loading: false });
                    } else {
                        // alert("Delete Faild !");
                        this.props.alert.info("No Data Found !");
                        this.setState({ loading: false });
                    }
                }).catch(function (error) {
                    // alert("Error");
                    console.log("No internet connection or Internal error");
                    // this.setState({ loading: false });
                    // alert("No internet connection or Internal error");
                });
        }


    }

    onSearchTypeChanged = (e) => {
        // alert(e.target.value)
        this.setState({
            search_type: e.target.value
        });
        this.loadData(e.target.value);
    }

    loadData(value) {
        this.setState({ loading: true });
        if (value == null && value == '') {

        } else {
            var data = [];
            var discount;
            // alert(value)
            // this.setState({ loading: true });
            if (value == 'quatation') {
                // axios.get('http://localhost:5006/quotation/getQuotationsList')
                axios.get(window.salesServer + '/quotation/getQuotationsList')
                    .then(response => {

                        if (response.data.success) {
                            var quatationListObj = response.data.quotations;
                            if (quatationListObj.length != 0) {
                                for (var i = 0; i < quatationListObj.length; i++) {
                                    if (quatationListObj[i].IS_DISCOUNT_PERCENTAGE) {
                                        discount = quatationListObj[i].DISCOUNT + "%"
                                    } else {
                                        discount = quatationListObj[i].DISCOUNT
                                    }
                                    data.push({
                                        id: quatationListObj[i].ID_INVOICE_HEADER,
                                        reference_no: quatationListObj[i].REFERENCE_NO,
                                        customer_code: quatationListObj[i].CUSTOMER_CODE,
                                        customer_name: quatationListObj[i].CUSTOMER_NAME,
                                        grows_amount: quatationListObj[i].GROSS_AMOUNT,
                                        discount: discount,
                                        net_amount: quatationListObj[i].NET_AMOUNT,
                                        invoice_date: quatationListObj[i].BILL_DATE,
                                        // out_standing: 'NaN',
                                        status: quatationListObj[i].STATUS,
                                    });
                                }
                                this.setState({ data: data });
                                this.setState({ loading: false });
                            } else {
                                for (var i = 0; i < quatationListObj.length; i++) {
                                    if (quatationListObj[i].IS_DISCOUNT_PERCENTAGE) {
                                        discount = quatationListObj[i].DISCOUNT + "%"
                                    } else {
                                        discount = quatationListObj[i].DISCOUNT
                                    }
                                    data.push({
                                        id: quatationListObj[i].ID_INVOICE_HEADER,
                                        reference_no: quatationListObj[i].REFERENCE_NO,
                                        customer_code: quatationListObj[i].CUSTOMER_CODE,
                                        customer_name: quatationListObj[i].CUSTOMER_NAME,
                                        grows_amount: quatationListObj[i].GROSS_AMOUNT,
                                        discount: discount,
                                        net_amount: quatationListObj[i].NET_AMOUNT,
                                        status: quatationListObj[i].STATUS
                                    });
                                }
                                this.setState({ data: data });
                                this.setState({ loading: false });
                                this.props.alert.info("No Data Found !");
                            }

                        } else {
                            // alert("Delete Faild !");
                            this.props.alert.info("No Data Found !");
                            this.setState({ loading: false });
                        }
                    }).catch(function (error) {
                        // alert("Error");
                        console.log("No internet connection or Internal error");
                        // this.setState({ loading: false });
                        // alert("No internet connection or Internal error");
                    });
            } else if (value == 'proformaInvoice') {
                // axios.get('http://localhost:5006/invoice/getProfomaInvoicesList')
                axios.get(window.salesServer + '/invoice/getProfomaInvoicesList')
                    .then(response => {

                        if (response.data.success) {
                            var invoiceListObj = response.data.invoices;
                            if (invoiceListObj.length != 0) {
                                for (var i = 0; i < invoiceListObj.length; i++) {
                                    if (invoiceListObj[i].IS_DISCOUNT_PERCENTAGE) {
                                        discount = invoiceListObj[i].DISCOUNT + "%"
                                    } else {
                                        discount = invoiceListObj[i].DISCOUNT
                                    }
                                    data.push({
                                        id: invoiceListObj[i].ID_INVOICE_HEADER,
                                        reference_no: invoiceListObj[i].REFERENCE_NO,
                                        customer_code: invoiceListObj[i].CUSTOMER_CODE,
                                        customer_name: invoiceListObj[i].CUSTOMER_NAME,
                                        grows_amount: invoiceListObj[i].GROSS_AMOUNT,
                                        discount: discount,
                                        out_standing: invoiceListObj[i].OUTSTANDING,
                                        invoice_date: invoiceListObj[i].BILL_DATE,
                                        net_amount: invoiceListObj[i].NET_AMOUNT,
                                        status: invoiceListObj[i].STATUS
                                    });
                                }
                                this.setState({ data: data });
                                this.setState({ loading: false });
                            } else {
                                for (var i = 0; i < invoiceListObj.length; i++) {
                                    if (invoiceListObj[i].IS_DISCOUNT_PERCENTAGE) {
                                        discount = invoiceListObj[i].DISCOUNT + "%"
                                    } else {
                                        discount = invoiceListObj[i].DISCOUNT
                                    }
                                    data.push({
                                        id: invoiceListObj[i].ID_INVOICE_HEADER,
                                        reference_no: invoiceListObj[i].REFERENCE_NO,
                                        customer_code: invoiceListObj[i].CUSTOMER_CODE,
                                        customer_name: invoiceListObj[i].CUSTOMER_NAME,
                                        grows_amount: invoiceListObj[i].GROSS_AMOUNT,
                                        discount: discount,
                                        net_amount: invoiceListObj[i].NET_AMOUNT,
                                        out_standing: invoiceListObj[i].OUTSTANDING,
                                        invoice_date: invoiceListObj[i].BILL_DATE,
                                        status: invoiceListObj[i].STATUS
                                    });
                                }
                                this.setState({ data: data });
                                this.setState({ loading: false });
                                this.props.alert.info("No Data Found !");

                            }

                        } else {
                            // alert("Delete Faild !");
                            this.props.alert.info("No Data Found !");
                            this.setState({ loading: false });
                        }
                    }).catch(function (error) {
                        // alert("Error");
                        console.log("No internet connection or Internal error");
                        // this.setState({ loading: false });
                        // alert("No internet connection or Internal error");
                    });
            } else {
                // axios.get('http://localhost:5006/invoice/getInvoicesList')
                axios.get(window.salesServer + '/invoice/getInvoicesList')
                    .then(response => {

                        if (response.data.success) {
                            var invoiceListObj = response.data.invoices;
                            console.log('invoiceListObj', invoiceListObj);
                            if (invoiceListObj.length != 0) {
                                for (var i = 0; i < invoiceListObj.length; i++) {
                                    if (invoiceListObj[i].IS_DISCOUNT_PERCENTAGE) {
                                        discount = invoiceListObj[i].DISCOUNT + "%"
                                    } else {
                                        discount = invoiceListObj[i].DISCOUNT
                                    }
                                    data.push({
                                        id: invoiceListObj[i].ID_INVOICE_HEADER,
                                        reference_no: invoiceListObj[i].REFERENCE_NO,
                                        customer_code: invoiceListObj[i].CUSTOMER_CODE,
                                        customer_name: invoiceListObj[i].CUSTOMER_NAME,
                                        grows_amount: invoiceListObj[i].GROSS_AMOUNT,
                                        discount: discount,
                                        out_standing: invoiceListObj[i].OUTSTANDING,
                                        invoice_date: invoiceListObj[i].BILL_DATE,
                                        net_amount: invoiceListObj[i].NET_AMOUNT,
                                        status: invoiceListObj[i].STATUS,
                                        deleted: invoiceListObj[i].DELETED
                                    });
                                }
                                this.setState({ data: data }, () => console.log(this.state.data));
                                this.setState({ loading: false });
                            } else {
                                for (var i = 0; i < invoiceListObj.length; i++) {
                                    if (invoiceListObj[i].IS_DISCOUNT_PERCENTAGE) {
                                        discount = invoiceListObj[i].DISCOUNT + "%"
                                    } else {
                                        discount = invoiceListObj[i].DISCOUNT
                                    }
                                    data.push({
                                        id: invoiceListObj[i].ID_INVOICE_HEADER,
                                        reference_no: invoiceListObj[i].REFERENCE_NO,
                                        customer_code: invoiceListObj[i].CUSTOMER_CODE,
                                        customer_name: invoiceListObj[i].CUSTOMER_NAME,
                                        grows_amount: invoiceListObj[i].GROSS_AMOUNT,
                                        discount: discount,
                                        net_amount: invoiceListObj[i].NET_AMOUNT,
                                        out_standing: invoiceListObj[i].OUTSTANDING,
                                        invoice_date: invoiceListObj[i].BILL_DATE,
                                        status: invoiceListObj[i].STATUS,
                                        deleted: invoiceListObj[i].DELETED
                                    });
                                }
                                this.setState({ data: data }, () => console.log(this.state.data));
                                this.setState({ loading: false });
                                this.props.alert.info("No Data Found !");

                            }

                        } else {
                            // alert("Delete Faild !");
                            this.props.alert.info("No Data Found !");
                            this.setState({ loading: false });
                        }
                    }).catch(function (error) {
                        // alert("Error");
                        console.log("No internet connection or Internal error");
                        // this.setState({ loading: false });
                        // alert("No internet connection or Internal error");
                    });
            }
        }


    }

    onPrint = (invoice_id) => {
        // alert(this.state.search_type +"rtrt -"+invoice_id)
        if (this.state.search_type == 'quatation') {
            var path = null;
            axios.get(window.reportServer + '/report/get/reportQuotationDuplicate',
                {
                    params: {
                        refId: invoice_id
                    }
                }
            )
                .then(response => {
                    path = response.data.path;
                    path = window.reportServer + "/" + path;
                    const url = path;
                    window.open(url, '_blank');
                }
                );
        } else if (this.state.search_type == 'proformaInvoice') {
            var address = null;
            axios.get(window.reportServer + '/report/get/reportInvoiceDuplicate', {
                params: {
                    invoiceNo: invoice_id
                }
            })
                .then(response => {
                    address = response.data.path;
                    address = window.reportServer + "/" + address;
                    const url = address;
                    window.open(url, '_blank');


                }
                );
        } else {
            var address = null;
            axios.get(window.reportServer + '/report/get/reportInvoiceDuplicate', {
                params: {
                    invoiceNo: invoice_id
                }
            })
                .then(response => {
                    address = response.data.path;
                    address = window.reportServer + "/" + address;
                    const url = address;
                    window.open(url, '_blank');


                }
                );
        }


    };


    onDelete = async (row) => {
        console.log('row', row);
        try {
            this.setState({ loading: true });
            const response = await axios.post(window.accountServer + '/transactionLedger/getTransactionHeader',
                {
                    transactionType: "INVOICE",
                    referenceId: row.original.id
                });

            if (!response.data.header) {
                this.setState({ loading: false });
                return null;
            }

            var transactionHeaderInfo = response.data.header;
            console.log('transactionHeaderInfo', transactionHeaderInfo);


            if (transactionHeaderInfo && transactionHeaderInfo[0]) {
                const response2 = await axios.post(window.accountServer + '/transactionLedger/reverseTransactions',
                    {
                        transactionHeaderId: transactionHeaderInfo[0].ID_TRANSACTION_LEDGER_HEADER,
                        transactionType: "INVOICE",
                        referenceId: row.original.id
                    });
            }

            const response3 = await axios.post(window.salesServer + '/invoice/deleteInvoice',
                {
                    invoiceId: row.original.id
                });

            this.loadData('invoice');
            this.setState({ loading: false });
        }
        catch (error) {
            this.setState({ loading: false });
        }
    }

    searchChange = (e) => {
        this.setState({
            selectValue: e.target.value,
            value:""
        })
        this.resetBtn();
    }

    resetBtn = () => {
        this.setState({
            value: '',
            selectValue: ''
        })
        this.populateFileds();
    }

    render() {
        const { classes } = this.props;
        let columns = [];
        if (this.state.search_type == 'quatation') {
            columns = [
                {
                    Header: "Quotation No",
                    accessor: "reference_no",
                    className: "justify-center",

                },
                {
                    Header: "Customer Code",
                    accessor: "customer_code",
                    className: "justify-center",

                },
                {
                    Header: "Customer Name",
                    className: "justify-center",
                    accessor: "customer_name"

                },
                {
                    Header: "Gross Amount",
                    className: "justify-center",
                    accessor: "grows_amount"

                },
                {
                    Header: "Discount",
                    className: "justify-center",
                    accessor: "discount"

                },
                {
                    Header: "Net Amount",
                    className: "justify-center",
                    accessor: "net_amount"

                },
                {
                    Header: "Quotation Date",
                    accessor: "invoice_date",
                    Cell: row => (
                        <div>
                            {moment(new Date(row.original.invoice_date)).format("YYYY-MM-DD")}
                        </div>
                    )

                },
                {
                    Header: "Print",
                    // accessor: "su",
                    width: 128,
                    Cell: row => (


                        <div className="flex items-center w-8 h-8">
                            {/* {this.state.search_type == 'invoice' ?  */}
                            <IconButton

                                onClick={(e) => {
                                    if (row) {

                                        reference_no = row.original.reference_no;
                                        // in_out_bound = row.original.in_out_bound;

                                        this.onPrint(reference_no)
                                    }
                                }}

                            >
                                <Icon className="text-blue">print</Icon>
                            </IconButton>

                            {/* : ''} */}


                        </div>
                    )
                }
            ]

        } else if (this.state.search_type == 'proformaInvoice') {
            columns = [
                {
                    Header: "Proforma Invoice No",
                    accessor: "reference_no",
                    className: "justify-start",
                    width: 200

                },
                // {
                //     Header: "Customer Code",
                //     accessor: "customer_code",
                //     className: "justify-start",
                //     width: 100

                // },
                {
                    Header: "Customer Name",
                    className: "justify-start",
                    accessor: "customer_name"

                },
                {
                    Header: "Gross Amount",
                    className: "justify-start",
                    accessor: "grows_amount",
                    width: 200

                },
                {
                    Header: "Discount",
                    className: "justify-start",
                    accessor: "discount",
                    width: 150

                },
                {
                    Header: "Net Amount",
                    className: "justify-start",
                    accessor: "net_amount",
                    width: 200

                },
                {
                    Header: "Out Standing",
                    className: "justify-start",
                    accessor: "out_standing",
                    width: 200

                },
                {
                    Header: "Invoice Date",
                    accessor: "invoice_date",
                    Cell: row => (
                        <div>
                            {moment(new Date(row.original.invoice_date)).format("YYYY-MM-DD")}
                        </div>
                    ),
                    width: 200

                },
                {
                    Header: "Print",
                    // accessor: "su",
                    width: 200,
                    className: "justify-right",
                    Cell: row => (


                        <div className="flex items-center w-8 h-8">
                            {/* {this.state.search_type == 'invoice' ?  */}
                            <IconButton

                                onClick={(e) => {
                                    if (row) {

                                        reference_no = row.original.reference_no;

                                        // in_out_bound = row.original.in_out_bound;

                                        this.onPrint(reference_no)
                                    }
                                }}

                            >
                                <Icon className="text-blue">print</Icon>
                            </IconButton>
                            <div className="px-4">
                                <Button
                                    // className="w-160"
                                    type="button"
                                    variant="raised"
                                    color="secondary"
                                    onClick={(ev) => {
                                        // alert(row.original.id)
                                        reference_no = row.original.reference_no;
                                        id = row.original.id;
                                        this.convertToInvoice(id, reference_no);

                                    }}
                                >
                                    Invoice
                         </Button>
                            </div>
                            {/* : ''} */}


                        </div>
                    )
                }
            ]
        } else {
            columns = [
                {
                    Header: "Invoice No",
                    accessor: "reference_no",
                    className: "justify-start",

                },
                {
                    Header: "Customer Code",
                    accessor: "customer_code",
                    className: "justify-start",

                },
                {
                    Header: "Customer Name",
                    className: "justify-start",
                    accessor: "customer_name"

                },
                {
                    Header: "Gross Amount",
                    className: "justify-start",
                    accessor: "grows_amount"

                },
                {
                    Header: "Discount",
                    className: "justify-start",
                    accessor: "discount"

                },
                {
                    Header: "Net Amount",
                    className: "justify-start",
                    accessor: "net_amount"

                },
                {
                    Header: "Out Standing",
                    className: "justify-start",
                    accessor: "out_standing"

                },
                {
                    Header: "Invoice Date",
                    accessor: "invoice_date",
                    Cell: row => (
                        <div>
                            {moment(new Date(row.original.invoice_date)).format("YYYY-MM-DD")}
                        </div>
                    )

                },
                {
                    Header: "Print",
                    // accessor: "su",
                    width: 128,
                    className: "justify-center",
                    Cell: row => (


                        <div className="flex items-center w-8 h-8">
                            {/* {this.state.search_type == 'invoice' ?  */}
                            <IconButton

                                onClick={(e) => {
                                    if (row) {

                                        reference_no = row.original.reference_no;
                                        // in_out_bound = row.original.in_out_bound;

                                        this.onPrint(reference_no)
                                    }
                                }}

                            >
                                <Icon className="text-blue">print</Icon>
                            </IconButton>

                            {/* : ''} */}


                        </div>
                    )
                },
                {
                    Header: "Delete",
                    // accessor: "su",
                    width: 128,
                    className: "justify-center",
                    Cell: row => (
                        <div className="flex items-center w-8 h-8">
                            {row.original.deleted && row.original.deleted == 1 ?
                                <div className="text-red">Deleted</div>
                                : <IconButton

                                    onClick={(e) => {
                                        if (row) {

                                            reference_no = row.original.reference_no;

                                            this.onDelete(row)
                                        }
                                    }}

                                >
                                    <Icon className="text-blue">delete</Icon>
                                </IconButton>}


                        </div>
                    )
                }
            ]
        }


        if (this.state.loading) {
            return (<Loader />);
        }

        else {

            return (
                <div>
                    <div className=" subtitle-color p-20">
                        <h2>Invoice View</h2>
                    </div>

                    <div className="p-20">

                        <div className="flex flex-wrap -mx-3 mb-8">
                            <div className="w-full md:w-2/3 search-margin">
                                {/* <div className="w-full md:w-1/3 mt-48"> */}
                                {/* <label> Gender </label> */}

                                <label className="md:w-1/3 ml-24 text-lg">
                                    <input onChange={this.onSearchTypeChanged} className="w-16 h-16" type="radio" name="searchType" value="quatation" checked={this.state.search_type === 'quatation'} /> Quotation</label>
                                <label className="md:w-1/3 ml-24 text-lg">
                                    <input onChange={this.onSearchTypeChanged} className="w-16 h-16" type="radio" name="searchType" value="invoice" checked={this.state.search_type === 'invoice'} /> Invoice</label>
                                {/* uncomment to enable proforma invoice */}
                                <label className="md:w-1/3 ml-24 text-lg">
                                    <input onChange={this.onSearchTypeChanged} className="w-16 h-16" type="radio" name="searchType" value="proformaInvoice" checked={this.state.search_type === 'proformaInvoice'} /> Proforma Invoice</label>



                                {/* <label className="md:w-1/3 ml-24 text-lg"><input onChange={(e) => this.onRadioChange('quatation')} className="w-16 h-16" type="radio" name="gender" value="quatation" checked={this.state.search_type === 'quatation'} />Quatation</label>
                                <label className="md:w-1/3 ml-24 text-lg"><input onChange={(e) => this.onRadioChange('invoice')} className="w-16 h-16" type="radio" name="gender" value="invoice" checked={this.state.search_type === 'invoice'} />Invoice</label> */}
                                {/* </div> */}
                            </div>

                            <div className="w-full md:w-1/2">
                                {/* <Icon className="-mb-32 -mr-16" color="action">search</Icon> */}
                                <span><span>

                                    <Select
                                        labelId="demo-simple-select-helper-label"
                                        id="demo-simple-select-helper"
                                        value={this.state.selectValue}
                                        onChange={this.searchChange}
                                    >
                                        <MenuItem value={0}>
                                            <em>All</em>
                                        </MenuItem>
                                        <MenuItem value={10}>Customer Name</MenuItem>
                                        <MenuItem value={20}>Gross Amount</MenuItem>
                                        <MenuItem value={30}>Net Amount</MenuItem>
                                    </Select>
                                </span><span>
                                        <TextField
                                            placeholder="Search for anything"
                                            className="pl-16"
                                            // fullWidth
                                            value={this.state.value}
                                            inputProps={{
                                                'aria-label': 'Search'
                                            }}
                                            onChange={this.handleSearchAny}
                                        />
                                    </span>
                                    <span>
                                        <Button variant="contained" color="primary" onClick={()=>{this.loadSearchData(this.state.value)}}>
                                            Search
                                        </Button>
                                    </span>
                                    <span>
                                        <Button variant="contained" color="primary" onClick={this.resetBtn}>
                                            Reset
                                        </Button>
                                    </span>
                                </span>
                            </div>
                        </div>

                        <div class="flex h-auto">

                            <div class="w-full bg-white h-auto">
                                <ReactTable
                                    getTrProps={(state, rowInfo, column) => {
                                        return {
                                            className: "cursor-pointer",
                                            onClick: (e, handleOriginal) => {

                                            }
                                        }
                                    }}
                                    data={this.state.data}
                                    columns={columns}
                                    defaultPageSize={10}
                                    className="-striped -highlight"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )


        }
    }
}

export default withStyles(styles, { withTheme: true })(withAlert(InvoiceView));


// WEBPACK FOOTER //
// ./src/main/content/sales/invoice/invoiceView.js